import { Cache, createCache, CreateCacheConfig, isCacheTypeSupported } from '@accedo/general-cache';
import { logger } from '@accedo/logger';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class CacheService {
  static createCache(config: CreateCacheConfig): Cache {
    if (isCacheTypeSupported(config.cacheType)) {
      return createCache(config);
    }
    logger.error(`Cache type ${config.cacheType} is not supported using memory fallback`);

    return createCache({ ...config, cacheType: 'memory' });
  }
}
